import { Component, ViewChild } from '@angular/core';
import { Events, MenuController, Nav, NavController, IonicApp, App } from 'ionic-angular';
//import { SplashScreen } from '@ionic-native/splash-screen';

import { Storage } from '@ionic/storage';

import { AboutPage } from '../pages/about/about';
import { AccountPage } from '../pages/account/account';
import { LoginPage } from '../pages/login/login';
import { MapPage } from '../pages/map/map';
import { SignupPage } from '../pages/signup/signup';
import { TabsPage } from '../pages/tabs-page/tabs-page';
import { TutorialPage } from '../pages/tutorial/tutorial';
import { SchedulePage } from '../pages/schedule/schedule';
import { SpeakerListPage } from '../pages/speaker-list/speaker-list';
import { SupportPage } from '../pages/support/support';

import { ConferenceData } from '../providers/conference-data';
import { UserData } from '../providers/user-data';
import { HomePage } from '../pages/home/home'
import { SadhonaFormPage } from '../pages/sadhona-form/sadhona-form';
import { MenteeListPage } from '../pages/mentee-list/mentee-list'
import { UserFormPage } from '../pages/user-form/user-form';
import { UserListPage } from '../pages/user-list/user-list';
import { MenteeGroupFormPage } from '../pages/mentee-group-form/mentee-group-form';
import { AssignMentorToMenteeGroupPage } from '../pages/assign-mentor-to-mentee-group/assign-mentor-to-mentee-group';
import { ViewSadhanaPage } from '../pages/view-sadhana/view-sadhana';
import { GroupListPage } from '../pages/group-list/group-list';
import { ChangePasswordPage } from '../pages/change-password/change-password'
import { AddMenteeToMenteeGroupPage } from '../pages/add-mentee-to-mentee-group/add-mentee-to-mentee-group';
import { ViewMyMenteesPage } from '../pages/view-my-mentees/view-my-mentees';
import { MentorApproveSadhanaPage } from '../pages/mentor-approve-sadhana/mentor-approve-sadhana'
import { MenteeApproveSadhanaPage } from '../pages/mentee-approve-sadhana/mentee-approve-sadhana'
import { EmailSadhanaPage } from '../pages/email-sadhana/email-sadhana';
export interface PageInterface {
  title: string;
  name: string;
  component: any;
  icon: string;
  logsOut?: boolean;
  index?: number;
  tabName?: string;
  tabComponent?: any;
}

@Component({
  templateUrl: 'app.template.html'
})
export class ConferenceApp {
  @ViewChild(Nav) nav: Nav;
  userType: any;

  navigationPages: PageInterface[] = [
    { title: 'Dashboard', name: 'HomePage', component: HomePage, icon: 'calendar' },
  ];

  public superAdminUserPages: PageInterface[] = [
    { title: 'Create User', name: 'UserFormPage', component: UserFormPage, icon: 'calendar' },
  ];

  public adminUserPages: PageInterface[] = [
    { title: 'Create User', name: 'UserFormPage', component: UserFormPage, icon: 'calendar' },
    { title: 'Seach users', name: 'UserListPage', component: UserListPage, icon: 'calendar' },
    { title: 'Create Mentee Group', name: 'MenteeGroupFormPage', component: MenteeGroupFormPage, icon: 'calendar' },
    { title: 'View Group', name: 'GroupListPage', component: GroupListPage, icon: 'calendar' },
    { title: 'Assign Mentor to Mentee Group', name: 'AssignMentorToMenteeGroupPage', component: AssignMentorToMenteeGroupPage, icon: 'calendar' },
    { title: 'Add Mentee to Mentee Group', name: 'AddMenteeToMenteeGroupPage', component: AddMenteeToMenteeGroupPage, icon: 'calendar' }
  ];

  public mentorUserPages: PageInterface[] = [
    { title: 'View My Mentees', name: 'ViewMyMenteesPage', component: ViewMyMenteesPage, icon: 'calendar' },
    { title: 'Approve Sadhana', name: 'MentorApproveSadhanaPage', component: MentorApproveSadhanaPage, icon: 'calendar' },
  ];

  public shadhanaPages: PageInterface[] = [
    { title: 'Enter Sadhana', name: 'SadhonaFormPage', component: SadhonaFormPage, icon: 'calendar' },
    { title: 'View Sadhana', name: 'ViewSadhanaPage', component: ViewSadhanaPage, icon: 'contacts' },
    { title: 'My Approved Sadhana', name: 'MenteeApproveSadhanaPage', component: MenteeApproveSadhanaPage, icon: 'contacts' }, 
    { title: 'Email Sadhana', name: 'EmailSadhanaPage', component: EmailSadhanaPage, icon: 'contacts' }, 
  ];
  public accountPages: PageInterface[] = [
    //{ title: 'My Account', name: 'IntroductionPage', component: AccountPage, icon: 'person' },
    { title: 'Change Password', name: 'ChangePasswordPage', component: ChangePasswordPage, icon: 'person' },
    { title: 'Logout', name: 'LoginPage', component: LoginPage, icon: 'log-out', logsOut: true }
  ];

  public settingsPages: PageInterface[] = [
    { title: 'Settings one', name: 'IntroductionPage', component: SupportPage, icon: 'bluetooth' }
  ];

  public legalPages: PageInterface[] = [
    { title: 'Terms of Use', name: 'IntroductionPage', component: AboutPage, icon: 'document' },
    { title: 'Privacy Policy', name: 'IntroductionPage', component: AboutPage, icon: 'body' },
    { title: 'About Big Top', name: 'IntroductionPage', component: AboutPage, icon: 'information-circle' }
  ];

  rootPage: any;
  username: any
  usertypename: any
  loggedIn: boolean;
  ismentor: boolean;
  constructor(
    public events: Events,
    public userData: UserData,
    public menu: MenuController,
    //public platform: Platform,
    // public confData: ConferenceData,
    public storage: Storage,
    private app: App,
    private ionicApp: IonicApp,
    //public splashScreen: SplashScreen,
  ) {
    this.enableMenu(false)
    this.listenToLoginEvents();
    this.setupBackButtonBehavior()
    //confData.load();
    this.checkNetworkConnection();
  }

  ngOnInit() {
    // Let's navigate from TabsPage to Page1

    this.userData.hasLoggedIn().then((result) => {
      if (result == null) {
        this.rootPage = LoginPage
        this.enableMenu(false);
      } else {
        this.storage.get('changepassword').then(val => {
          if (val) {
            this.rootPage = HomePage
          } else {
            this.enableMenu(false);
            this.rootPage = ChangePasswordPage
          }
        })
        this.enableMenu(true);
      }
    });



    this.userData.getUserType().then(
      result => {
        if (result == null) {
          this.userType = null
          this.rootPage = LoginPage
        } else {
          this.userType = result
          if (this.userType == 1) {
            this.usertypename = 'Super Admin'
          } else if (this.userType == 2) {
            this.usertypename = 'Admin'
          } else if (this.userType == 4) {
            this.usertypename = 'Mentor'
          } else if (this.userType == 0) {
            this.usertypename = 'Mentee'
          }
        }
      }
    )

    this.storage.get('username').then((value) => {
      this.username = value
    });

  }



  openPage(page: PageInterface) {
    let params = {};

    // the nav component was found using @ViewChild(Nav)
    // setRoot on the nav to remove previous pages and only have this page
    // we wouldn't want the back button to show in this scenario
    if (page.index) {
      params = { tabIndex: page.index };
    }
    if (page.logsOut === true) {
      // Give the menu time to close before changing to logged out
      this.userData.logout();

      this.nav.setRoot(page.name, params).then(res => {
        console.log('reached')
        this.enableMenu(false)
      }).catch((err: any) => {
        console.log(`Didn't set nav root: ${err}`);
      });
    } else {
      if (this.nav.getActiveChildNavs().length && page.index != undefined) {
        this.nav.getActiveChildNavs()[0].select(page.index);
      } else {
        // Set the root of the nav with params if it's a tab index
        this.nav.setRoot(page.name, params).catch((err: any) => {
          console.log(`Didn't set nav root: ${err}`);
        });
      }
    }
    // If we are already on tabs just change the selected tab
    // don't setRoot again, this maintains the history stack of the
    // tabs even if changing them from the menu




  }

  openTutorial() {
    this.nav.setRoot(TutorialPage);
  }

  listenToLoginEvents() {
    this.events.subscribe('user:login', (type, name, ismentor) => {
      this.username = name
      this.userType = type
      if (this.userType == 1) {
        this.usertypename = 'Super Admin'
      } else if (this.userType == 2) {
        this.usertypename = 'Admin'
      } else if (this.userType == 4) {
        this.usertypename = 'Mentor'
      } else if (this.userType == 0) {
        this.usertypename = 'Mentee'
      }
      this.ismentor = ismentor
      this.enableMenu(true);
    });

    this.events.subscribe('user:signup', () => {
      this.enableMenu(true);
    });

    this.events.subscribe('menu:toggle', (val) => {
      if (val) {
        this.enableMenu(true);
      } else {
        this.enableMenu(false);
      }
    });

    this.events.subscribe('user:logout', () => {
      // console.log('reached')
      this.userType = null
      this.enableMenu(false);
      this.nav.setRoot('LoginPage').catch((err: any) => {
        console.log(`Didn't set nav root: ${err}`);
      });
    });
  }

  enableMenu(loggedIn: boolean) {
    this.menu.enable(loggedIn);
  }

  // platformReady() {
  //   // Call any initial plugins when ready
  //   this.platform.ready().then(() => {
  //     //this.splashScreen.hide();
  //   });
  // }

  isActive(page: PageInterface) {
    let childNav = this.nav.getActiveChildNavs()[0];

    // Tabs are a special case because they have their own navigation
    if (childNav) {
      if (childNav.getSelected() && childNav.getSelected().root === page.tabComponent) {
        return 'primary';
      }
      return;
    }

    if (this.nav.getActive() && this.nav.getActive().name === page.name) {
      return 'primary';
    }
    return;
  }


  private setupBackButtonBehavior() {

    // If on web version (browser)
    if (window.location.protocol !== "file:") {

      // Register browser back button action(s)
      window.onpopstate = (evt) => {

        // Close menu if open
        if (this.menu.isOpen()) {
          this.menu.close();
          return;
        }

        // Close any active modals or overlays
        let activePortal = this.ionicApp._loadingPortal.getActive() ||
          this.ionicApp._modalPortal.getActive() ||
          this.ionicApp._toastPortal.getActive() ||
          this.ionicApp._overlayPortal.getActive();

        if (activePortal) {
          activePortal.dismiss();
          return;
        }

      };

      // Fake browser history on each view enter
      // this.app.viewDidEnter.subscribe((app) => {
      //   console.log('whats the catch', app)
      //   history.pushState (null, null, "");
      // });

    }

  }

  checkNetworkConnection() {
    if (!navigator) {
      return false;
    }
    window.addEventListener('offline', () => {
      //Do task when no internet connection
    });
    window.addEventListener('online', () => {
      //Do task when internet connection
      this.events.publish('sadhona-offline-data-entry')
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts